export default "__VITE_ASSET__90855d6e__"